import { useTranslation } from 'react-i18next';
import type { DrawPrizeDto } from '~shared/schemas';
import { PRIZE_TYPE_IMAGE } from '~/lib/prize-type-image';

/** Картинка типа приза на лендинге (connect-landing-draw, design, решение 6); alt — переводимая подпись категории. */
export function PrizeTypeImage({ prize, className }: { prize: Pick<DrawPrizeDto, 'category'>; className?: string }) {
  const { t } = useTranslation('landing');
  return <img className={className} src={PRIZE_TYPE_IMAGE[prize.category]} alt={t(`gifts.category.${prize.category}`)} />;
}
